import Loader from "components/Loader/Loader";
import DateSelector from "Dashboard/components/DateSelector";
import { useAppDispatch } from "hooks/hooks";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FormatDateIso, FormatDateShort } from "utils/dateUtils";
import { IConsumable } from "../domain/IConsumable";
import {
  getBasicConsumablesData,
  selectState,
} from "../slices/dtConsumables.slice";
import { FormatNumberOrNull, FormatNumberWithUnitOrNull } from "utils/numberUtils";
import { categoryDictionary } from "utils/translationDictionary";

export const ConsumablesPreview = () => {
  const { consumables, loading } = useSelector(selectState);
  const [dateFrom, setDateFrom] = useState<Date | null>(null);
  const [dateTo, setDateTo] = useState<Date | null>(null);
  const dispatch = useAppDispatch();

  const selectDate = useCallback((data: { dateFrom: Date; dateTo: Date }) => {
    setDateFrom(data.dateFrom);
    setDateTo(data.dateTo);
  }, []);

  useEffect(() => {
    if (dateFrom && dateTo) {
      dispatch(
        getBasicConsumablesData({
          dateFrom: FormatDateIso(dateFrom),
          dateTo: FormatDateIso(dateTo),
        })
      );
    }
  }, [dispatch, dateFrom, dateTo]);

  return (
    <>
      <div className="daily-table-consumables loading-container">
        {loading && <Loader />}
        <div className="previewHeader">
          <div className="bolded red">POTROŠNI MATERIJALI</div>
          <div>
            <DateSelector showYear={false} selectDate={selectDate} />
          </div>
        </div>
        <div className="extendedPreviewBody">
          {consumables.map((consumable: IConsumable) => (
            <div className="singleConsumable">
              <span className="daily-table-consumables-item text-overflow">- {consumable.itemName}</span>
              <span className="daily-table-consumables-quantity">{FormatNumberOrNull(consumable.exemptionQuantityAmount)}</span>
              <span className="daily-table-consumables-quantity-label">izdato</span>
              <span className="daily-table-consumables-price text-overflow">{FormatNumberWithUnitOrNull(consumable.pricePerUnit, 'rsd')}</span>
              <span className="daily-table-consumables-price-label">cena</span>
              <span className="daily-table-consumables-category">{categoryDictionary[consumable.category]}</span>
              <span className="daily-table-consumables-date">{FormatDateShort(consumable.date)}</span>
            </div>
          ))}
          {consumables.length < 4 && <div className="singleConsumable"></div>}
          {consumables.length < 3 && <div className="singleConsumable"></div>}
          {consumables.length < 2 && <div className="singleConsumable"></div>}
          {consumables.length < 1 && <div className="singleConsumable"></div>}
        </div>
      </div>
    </>
  );
};
